import { memo } from "react";

export type FaviconProps = Omit<React.ComponentProps<"img">, "src"> & {
  /** The URL of the website to get the favicon for */
  uri: string;

  /** The size quality of the favicon in pixels (default is 16) */
  size?: number;
};

/**
 * A component that displays the favicon of a given website URL.
 * Features:
 * - Fetches favicon using Google's favicon service
 * - Configurable size
 * - Accepts standard img element props
 *
 * @example
 * ```tsx
 * <Favicon uri="https://www.example.com" size={32} />
 * ```
 */
export const Favicon = memo(({ uri, size = 16, ...props }: FaviconProps) => {
  const domain = new URL(uri).host;

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`}
      alt={`Favicon for ${domain}`}
      width={size}
      height={size}
      {...props}
    />
  );
});
